export const AudienceAccessTypes = Object.freeze({
  PUBLIC: 'PUBLIC',
  PRIVATE_PASSWORD_REQUIRED: 'PRIVATE_PASSWORD_REQUIRED',
  PRIVATE_REGISTRATION_REQUIRED: 'PRIVATE_REGISTRATION_REQUIRED',
  PRIVATE_SSO_REQUIRED: 'PRIVATE_SSO_REQUIRED',
  PRIVATE_SELF_REGISTRATION_REQUIRED: 'PRIVATE_SELF_REGISTRATION_REQUIRED'
});